export const withColor = (c: string, s: string) => {
  return `%c{${c}}${s}%c{}`;
};
